export default {"src":"/_next/static/media/mdi_users-add-outline.f7aa4fab.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};